module.exports = __webpack_public_path__ + "img/chinesecompany204.21cb98f2.png";